import Head from "next/head";
import { useRouter } from "next/compat/router";

function CanonicalUrl({
  forcePath = false,
  forcedPath = "/",
}) {
  const router = useRouter();

  const href = () => {
    const baseUrl = process.env.NEXT_PUBLIC_BASE_URL;
    const locale = router?.locale === router?.defaultLocale ? "" : `/${router.locale}`;
    const path = forcePath ? forcedPath : router?.asPath?.split("?")?.[0];

    return `${baseUrl}${locale}${path}`;
  }

  return (
    <Head>
      <link rel="canonical" href={href()} data-testid="canonical-url"/>
    </Head>
  );
}

export default CanonicalUrl;
